module.exports = __webpack_public_path__ + "img/colonne_de_douche.2a23b98.svg";